import { useCallback, useState } from "react";
import { message } from "antd";
import { getProjectById } from "../../api/projectApi";

export default function useProject() {
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchProject = useCallback(async (id) => {
    if (!id) return null;

    setLoading(true);
    try {
      const data = await getProjectById(id);
      setProject(data);
      return data;
    } catch (error) {
      console.error(error);
      message.error("Failed to load project details");
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return { project, loading, fetchProject };
}